import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export const ForbiddenPage = () => (
  <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
    <div className="text-center max-w-md">
      <ShieldAlert className="h-12 w-12 mx-auto text-rose-500" />
      <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">Access denied</h1>
      <p className="mt-2 text-slate-500">You do not have permission to view this page.</p>
      <Link to="/" className="inline-block mt-4 px-4 py-2 bg-navy-800 text-white rounded-md hover:bg-navy-900">Back to home</Link>
    </div>
  </div>
);

export const NotFoundPage = () => (
  <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
    <div className="text-center max-w-md">
      <h1 className="font-display text-6xl font-bold text-navy-800">404</h1>
      <p className="mt-2 text-slate-500">The page you are looking for does not exist.</p>
      <Link to="/" className="inline-block mt-4 px-4 py-2 bg-navy-800 text-white rounded-md hover:bg-navy-900">Back to home</Link>
    </div>
  </div>
);
